<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <ng-container *ngIf="failedToLoadData">
      <span
        id="icon-alert"
        class="mdi mdi-alert-circle text-danger ml-1"
        ngbTooltip="Failed to load data."
        placement="right"
      ></span>
      <ngb-alert
        id="banner-alert"
        class="mb-0 py-0 pl-2 pr-4 ml-1"
        [dismissible]="false"
      >
        <strong class="mr-1">Failed to load data.</strong>
      </ngb-alert>
    </ng-container>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right class="header-size">
    <nf-form-control class="form-class">
      <input
        type="text"
        class="form-control"
        placeholder="Search Table..."
        [formControl]="searchText"
      />
    </nf-form-control>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <nf-table-layout
      tableTitle="Raw Data"
      [autoResizeGrid]="false"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [data]="externalFileDetails$ | async"
      hideClearAll
      hideSearch
      [hideTitle]="true"
    >
    </nf-table-layout> </nf-grid-wrapper-content
></nf-grid-wrapper>
